const getInitialDestinationOrHotel = (
	destinations,
	hotels,
	preselectedValue
) => {
	if (!preselectedValue) {
		return null;
	}

	const preselectedDestinationOrHotel = preselectedValue.isHotel
		? hotels.find(
				hotel =>
					hotel?.value?.toUpperCase() === preselectedValue?.value?.toUpperCase()
		  )
		: destinations.find(
				gateway =>
					gateway?.value?.toUpperCase() ===
					preselectedValue?.value?.toUpperCase()
		  );

	return {
		isHotel: preselectedDestinationOrHotel?.isHotel ?? false,
		label: preselectedDestinationOrHotel?.label,
		value: preselectedDestinationOrHotel?.value
	};
};

export default getInitialDestinationOrHotel;
